import { render } from "./Titulopagina.vue?vue&type=template&id=31c88cd5"
import script from "./Titulopagina.vue?vue&type=script&lang=js"
export * from "./Titulopagina.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__